const scriptsTypes = {

  index: {
    request: "SCRIPTS_INDEX_REQUEST",
    success: "SCRIPTS_INDEX_SUCCESS",
    failure: "SCRIPTS_INDEX_FAILURE"
  },

  update: {
    request: "UPDATE_SCRIPT_REQUEST",
    success: "UPDATE_SCRIPT_SUCCESS",
    failure: "UPDATE_SCRIPT_FAILURE"
  },

  create: {
    request: "CREATE_SCRIPT_REQUEST",
    success: "CREATE_SCRIPT_SUCCESS",
    failure: "CREATE_SCRIPT_FAILURE"
  },

  destroy: {
    request: "DESTROY_SCRIPT_REQUEST",
    success: "DESTROY_SCRIPT_SUCCESS",
    failure: "DESTROY_SCRIPT_FAILURE"
  },

  reset: "RESET_SCRIPTS",

  reset_errors: "RESET_SCRIPT_ERRORS"

}

export default scriptsTypes



// WEBPACK FOOTER //
// ./src/js/constants/scriptsTypes.js